<div class="container-fluid posts-dashboard">
  <app-content-tab-list activeTab="1" type="twitter" category="Twitter"></app-content-tab-list>

  <div class="dashboard-header mt-4">
    <div class="home-details">
      <h5 class="home-title">Posts Dashboard</h5>
      <p class="home-subtitle mb-0">Fetch and monitor the latest posts from active golden handles</p>
    </div>
  </div>

  @if (loading) {
    <div class="dashboard-empty">Loading post collection...</div>
  } @else if (!run) {
    <div class="dashboard-empty">
      <i class="las la-chart-bar"></i>
      <h6>No collection runs yet</h6>
      <p>Start a fetch to populate post statistics for every active golden handle.</p>
    </div>
  } @else {
    @if (isActive) {
    <div class="run-panel running">
      <div class="run-heading">
        <div>
          <span class="pulse-dot"></span>
          <span class="run-status" [class.active]="isActive" [class.failed]="run.status === 'failed'">{{ run.status }}</span>
          <span class="run-date">Latest run · {{ run.startedAt || run.createdAt | date: "medium" }}</span>
        </div>
        <div class="progress-total"><strong>{{ progress }}%</strong><small>complete</small></div>
      </div>
      <div class="progress-track"><span [style.width.%]="progress"></span></div>
      <div class="live-stats">
        <div><small>Current handle</small><strong>{{ run.currentHandle ? "@" + run.currentHandle : "Waiting…" }}</strong></div>
        <div><small>Page</small><strong>{{ run.pagesCompleted || 0 | number: "1.0-0" }}</strong></div>
        <div><small>Posts fetched</small><strong>{{ run.currentHandlePostsFetched || 0 | number: "1.0-0" }}</strong></div>
        <div><small>New posts saved</small><strong>{{ run.postsSaved || 0 | number: "1.0-0" }}</strong></div>
      </div>
      <div class="progress-caption">
        <span>{{ run.processedHandles || 0 | number: "1.0-0" }} of {{ run.totalHandles || 0 | number: "1.0-0" }} handles processed</span>
        <span>@if (isActive) { <i class="las la-spinner la-spin update-spinner"></i> }{{ isActive ? "Updating automatically" : "Collection run finished" }}</span>
      </div>
    </div>
    }

    <div class="stats-grid">
      <div class="stat-card fetched"><div class="stat-heading"><span>Posts fetched</span><i class="las la-cloud-download-alt"></i></div><strong>{{ run.collected || 0 | number: "1.0-0" }}</strong><small>Total posts received from X</small></div>
      <div class="stat-card success"><div class="stat-heading"><span>Completed</span><i class="las la-check-circle"></i></div><strong>{{ completedHandles | number: "1.0-0" }}</strong><small>Handles fetched successfully</small></div>
      <div class="stat-card neutral"><div class="stat-heading"><span>Fetching</span><i class="las la-sync"></i></div><strong>{{ fetchingHandles | number: "1.0-0" }}</strong><small>Handles currently being fetched</small></div>
      <div class="stat-card danger"><div class="stat-heading"><span>Failed</span><i class="las la-exclamation-circle"></i></div><strong>{{ failedHandles | number: "1.0-0" }}</strong><small>Handles with fetch errors</small></div>
    </div>

    <div class="results-card">
      <div class="results-header">
        <div><h6>Collection by handle</h6><p>Detailed outcome for each golden handle in this run</p></div>
        <span class="processed-count"><strong>{{ results.length | number: "1.0-0" }}</strong> results</span>
      </div>
      @if (results.length) {
      <div class="table-responsive results-table">
        <table class="table mb-0">
          <thead><tr><th>Golden handle</th><th>Status</th><th>Total posts</th><th>Last fetched at</th></tr></thead>
          <tbody>
            @for (result of results | paginate: { itemsPerPage: perPage, currentPage: page, totalItems: results.length, id: 'twitter-posts-dashboard' }; track result.goldenListMemberId) {
              <tr>
                <td>
                  <strong>{{ result.name || result.handle }} <button class="handle-view" type="button" title="View Golden Handle" (click)="openGoldenHandle(result)"><i class="las la-eye"></i></button></strong>
                  <small>@{{ result.handle }}</small>
                </td>
                <td>
                  <span class="status-with-details">
                    <span class="result-status" [class.fetching]="result.status === 'fetching'" [class.failed]="result.status === 'failed' || result.status === 'not_fetched'">{{ result.status === 'not_fetched' ? 'Not fetched' : result.status }}</span>
                    @if (result.status === 'failed') {
                      <ng-template #failureDetails>
                        <div class="failure-tooltip">
                          <strong>Fetch progress</strong>
                          <span><small>Pages fetched</small><b>{{ result.pagesFetched || 0 | number: "1.0-0" }}</b></span>
                          <span><small>Posts fetched</small><b>{{ result.postsFetched || 0 | number: "1.0-0" }}</b></span>
                          <span><small>New posts saved</small><b>{{ result.postsSaved || 0 | number: "1.0-0" }}</b></span>
                          <div class="failure-message">
                            <small>Error</small>
                            <span>{{ result.message || "No error details were recorded." }}</span>
                          </div>
                        </div>
                      </ng-template>
                      <button
                        class="failure-info"
                        type="button"
                        aria-label="Show failure details"
                        [tooltip]="failureDetails"
                        placement="top"
                        container="body"
                        containerClass="fetch-failure-tooltip"
                        triggers="hover focus"
                      >
                        <i class="las la-info-circle"></i>
                      </button>
                    }
                  </span>
                </td>
                <td>{{ result.collected || 0 | number: "1.0-0" }}</td>
                <td>{{ result.lastFetchedAt ? (result.lastFetchedAt | date: "medium") : "—" }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      @if (results.length > perPage) {
        <div class="results-pagination">
          <pagination-controls id="twitter-posts-dashboard" (pageChange)="pageChange($event)"></pagination-controls>
        </div>
      }
      } @else {
        <div class="results-empty">
          <span class="empty-icon"><i class="las la-stream"></i></span>
          <div>
            <h6>{{ isActive ? "Results are on the way" : "Detailed results unavailable" }}</h6>
            <p>{{ isActive ? "Each handle will appear here as soon as it is processed." : "Run Fetch Latest Posts again to generate the new per-handle breakdown." }}</p>
          </div>
        </div>
      }
    </div>
  }

</div>

@if (selectedGoldenHandle) {
  <app-golden-handle-modal [goldenHandle]="selectedGoldenHandle" (closed)="closeGoldenHandle()"></app-golden-handle-modal>
}
